import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { isEmpty } from "lodash-es";
import { ReactNode, Suspense } from "react";
import { SheetDetent } from "react-modal-sheet";

import { ModalDialog } from "@/components/General/Modal/components/modalDialog";
import { ModalSheet } from "@/components/General/Modal/components/modalSheet";
import { ModalContextProvider } from "@/components/General/Modal/context/modal.context";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = {
    modalType: ModalType;
    descriminator?: string;
    className?: string;
    sheetDetent?: SheetDetent;
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    confirmButtonText?: string;
    confirmButtonColor?: ButtonComponentProps["color"];
    cancelButtonText?: string;
    open: boolean;
    active?: boolean;
    closable?: boolean;
    formId?: string;
    isLoading?: boolean;
    isConfirmDisabled?: boolean;
    withFooter?: boolean;
    autoFocus?: boolean;
    centered?: boolean;
    scrollable?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
    setOpen?: (newState: boolean) => void;
    onOpenEnd?: () => void;
    children?: ReactNode;
};

const _Modal = ({
    modalType,
    descriminator,
    className,
    sheetDetent,
    title,
    subtitle,
    size,
    confirmButtonText,
    confirmButtonColor,
    cancelButtonText,
    open,
    active,
    closable,
    formId,
    isLoading,
    isConfirmDisabled,
    withFooter,
    autoFocus,
    centered,
    scrollable,
    onConfirm,
    onCancel,
    setOpen,
    onOpenEnd,
    children
}: Props) => {
    const { breakpoints } = useBreakpoint();

    if (isEmpty(breakpoints)) return null;

    return (
        <ModalContextProvider
            modalType={modalType}
            descriminator={descriminator}
            sheetDetent={sheetDetent}
            title={title}
            subtitle={subtitle}
            size={size}
            confirmButtonText={confirmButtonText}
            confirmButtonColor={confirmButtonColor}
            cancelButtonText={cancelButtonText}
            open={open}
            active={active}
            formId={formId}
            isLoading={isLoading}
            isConfirmDisabled={isConfirmDisabled}
            withFooter={withFooter}
            autoFocus={autoFocus}
            closable={closable}
            centered={centered}
            scrollable={scrollable}
            onConfirm={onConfirm}
            onCancel={onCancel}
            setOpen={setOpen}
            onOpenEnd={onOpenEnd}
        >
            <Suspense>
                {!breakpoints.md && (
                    <ModalSheet className={className}>{children}</ModalSheet>
                )}
                {breakpoints.md && (
                    <ModalDialog className={className}>{children}</ModalDialog>
                )}
            </Suspense>
        </ModalContextProvider>
    );
};

export const Modal = withBreakpoints(_Modal);
